var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomTypedEvent, CustomEventUtils, Debounce, Utils, P, PCSS, CustomElement, Watch, Defaults, ViewChild, PropertyChangeEvent, PropertyChangeEventName } from '@pacem/pacem-core';
import { HistoryService } from '@pacem/pacem-foundation';
import { PacemItemElement, PacemItemsContainerBaseElement } from './types-components';
import { CHAR_COUNTER_CHILD } from './char-counter';
//namespace Pacem.Components.Scaffolding {
const EXECUTECOMMAND_NAME = 'execute';
const EMPTY_CONTENT = '<p><br></p>';
class ContenteditableChangeEvent extends CustomTypedEvent {
    constructor(html) {
        super('contenteditablechange', { html: html });
    }
}
export class PacemContenteditableCommandElement extends PacemItemElement {
    constructor() {
        super(...arguments);
        this._containerPropChangeHandler = (evt) => {
            const p = evt.detail;
            this.containerPropertyChangedCallback(p.propertyName, p.oldValue, p.currentValue, p.firstChange);
        };
    }
    execCommand(...args) {
        const me = this;
        if (me.disabled) {
            return;
        }
        me.exec.apply(me, args).then(_ => {
            me.dispatchEvent(new Event(EXECUTECOMMAND_NAME));
        }, e => {
            console.error(e);
        });
    }
    connectedCallback() {
        super.connectedCallback();
        Utils.addClass(this, PCSS + '-contenteditable-command');
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const cnt = this.container;
        if (!Utils.isNull(cnt)) {
            this.contentElement = cnt.contentElement;
            cnt.addEventListener(PropertyChangeEventName, this._containerPropChangeHandler, false);
        }
    }
    disconnectedCallback() {
        const cnt = this.container;
        if (!Utils.isNull(cnt)) {
            cnt.removeEventListener(PropertyChangeEventName, this._containerPropChangeHandler, false);
        }
        super.disconnectedCallback();
    }
    containerPropertyChangedCallback(name, old, val, first) {
        if (name === 'range') {
            this.range = val;
        }
    }
}
__decorate([
    Watch()
], PacemContenteditableCommandElement.prototype, "range", void 0);
__decorate([
    Watch()
], PacemContenteditableCommandElement.prototype, "contentElement", void 0);
function isFileCommand(obj) {
    return obj instanceof PacemContenteditableCommandElement && 'pasteCallback' in obj && typeof obj['pasteCallback'] === 'function';
}
function isElement(node) {
    return node?.nodeType == Node.ELEMENT_NODE;
}
let PacemContenteditableElement = class PacemContenteditableElement extends PacemItemsContainerBaseElement {
    constructor() {
        super('rich text editor');
        this._focusHandler = (evt) => {
            this._ensureInteractiveMarkup();
        };
        this._blurHandler = (evt) => {
            // clean up the output
            const container = this._container;
            for (let command of this.items) {
                command.cleanUp(container);
            }
            this._checkChangedHandler(evt);
        };
        this._pasteHandler = (evt) => {
            // I'll manage it myself!
            evt.preventDefault();
            const range = this.range, files = evt.clipboardData.files;
            if (!Utils.isNull(range) && files.length === 0) {
                const text = evt.clipboardData.getData('text/plain');
                const plainText = text.replace(/</gi, '&lt;').replace(/\n/gi, '<br />');
                const frag = range.createContextualFragment(plainText);
                range.deleteContents();
                range.insertNode(frag);
                this._checkChangedHandler(evt);
            }
            else {
                for (let j = 0; j < files.length; j++) {
                    const f = files.item(j);
                    for (let cmd of this.items) {
                        if (isFileCommand(cmd)) {
                            cmd.pasteCallback(f).then(_ => this._checkChangedHandler(evt), _ => { });
                        }
                    }
                }
                // this._checkAndSynchronizeHandler(evt);
            }
        };
        this._shortcutHandler = (evt) => {
            // prevent any default shortcut combo apart from 'copy', 'cut' and 'paste' (mainly due to the clipboard access limitations)
            if (evt.ctrlKey && ['C', 'V', 'X'].indexOf(evt.key?.toUpperCase()) === -1) {
                // Let it manage it only if the relevant command is available
                evt.preventDefault();
            }
        };
        this._inputHandler = (evt) => {
            this._fixRangeMarkup();
            this._checkChangedHandler(evt);
        };
        this._checkChangedHandler = (evt) => {
            const container = this._container, inputHtml = container.innerHTML;
            var html = inputHtml;
            if (Utils.isNullOrEmpty(inputHtml)
                || inputHtml === '<br>'
                || inputHtml === EMPTY_CONTENT) {
                container.innerHTML = EMPTY_CONTENT;
                html = '';
            }
            if (html != this.value) {
                this.changeHandler(new ContenteditableChangeEvent(html));
                if (this.value != this.#history.current) {
                    this._updateHistory();
                }
            }
            // fire history change in any case
            this._fireHistoryChange();
        };
        this._selectionChangeHandler = (evt) => {
            const selection = document.getSelection();
            if (selection && selection.anchorNode && this._container.contains(selection.anchorNode)) {
                const range = selection.getRangeAt(0);
                this.range = range.cloneRange();
            }
            else {
                this.range = null;
            }
        };
        //this._workspace = document.createElement('div');
    }
    #history;
    get history() {
        return this.#history;
    }
    reset() {
        super.reset();
        this.#history.reset();
        this._fireHistoryChange();
    }
    _fireHistoryChange() {
        const h = this.#history;
        this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'history', oldValue: h, currentValue: h }));
    }
    convertValueAttributeToProperty(attr) {
        return attr;
    }
    toggleReadonlyView(readonly) {
        this._dashboard.hidden = readonly;
        if (readonly) {
            this._container.removeAttribute('contenteditable');
        }
        else {
            this._container.setAttribute('contenteditable', 'true');
            document.execCommand("defaultParagraphSeparator", false, "p");
        }
    }
    register(item) {
        if (super.register(item)) {
            item.addEventListener(EXECUTECOMMAND_NAME, this._checkChangedHandler, false);
            return true;
        }
        return false;
    }
    unregister(item) {
        if (super.unregister(item)) {
            item.removeEventListener(EXECUTECOMMAND_NAME, this._checkChangedHandler, false);
            return true;
        }
        return false;
    }
    /** @override */
    get preventKeyboardSubmit() {
        return true;
    }
    get inputFields() {
        return [this._container];
    }
    get contentElement() {
        return this._container;
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            if (CustomEventUtils.isInstanceOf(evt, ContenteditableChangeEvent)) {
                const html = this.value = evt.detail.html;
                resolve(html);
                // find a less-instrusive way to call this...
                this._selectionChangeHandler(evt);
            }
            else
                resolve(this.value);
        });
    }
    _fixRangeMarkup() {
        const range = this.range, fnDownwards = (node) => {
            node.childNodes.forEach(i => fnDownwards(i));
            if (isElement(node) && node.tagName === 'SPAN') {
                Element.prototype.replaceWith.apply(node, Array.from(node.childNodes));
            }
            else if (node instanceof HTMLElement) {
                node.removeAttribute('style');
            }
        }, fn = (node) => {
            let element = node;
            if (!isElement(element)) {
                element = node.parentElement;
            }
            fnDownwards(element);
        };
        if (!Utils.isNull(range)) {
            fn(range.commonAncestorContainer);
        }
    }
    _ensureInteractiveMarkup() {
        const workspace = this._container, nodes = workspace.childNodes, childCount = nodes.length;
        if (childCount == 0 || workspace.innerHTML === EMPTY_CONTENT) {
            workspace.innerHTML = EMPTY_CONTENT;
        }
        else {
            let node, range;
            const closeRange = (n) => {
                range.setEndAfter(n);
                const p = document.createElement('p');
                range.surroundContents(p);
            };
            for (let j = 0; j < childCount; j++) {
                node = nodes.item(j);
                if (!(node instanceof Element)) {
                    if (Utils.isNull(range)) {
                        range = document.createRange();
                        range.setStartBefore(node);
                    }
                }
                else if (range) {
                    closeRange(node.previousSibling);
                    range = null;
                }
            }
            // open range?
            if (!Utils.isNull(range)) {
                closeRange(node);
            }
        }
    }
    _updateHistory() {
        this.#history.push(this.value);
        this._fireHistoryChange();
    }
    acceptValue(val) {
        if (!Utils.isNull(this._container) && /*the following `if` statement prevents from flashing the content and writing backwards!*/ val != this._container.innerHTML) {
            this._container.innerHTML = val;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const container = this._container;
        this.#history = new HistoryService(this.value);
        container.addEventListener('blur', this._blurHandler, false);
        container.addEventListener('keydown', this._shortcutHandler, false);
        container.addEventListener('focus', this._focusHandler, false);
        container.addEventListener('input', this._inputHandler, false);
        container.addEventListener('paste', this._pasteHandler, false);
        document.addEventListener('selectionchange', this._selectionChangeHandler, false);
    }
    disconnectedCallback() {
        document.removeEventListener('selectionchange', this._selectionChangeHandler, false);
        const container = this._container;
        if (!Utils.isNull(container)) {
            container.removeEventListener('keydown', this._shortcutHandler, false);
            container.removeEventListener('blur', this._blurHandler, false);
            container.removeEventListener('focus', this._focusHandler, false);
            container.removeEventListener('input', this._inputHandler, false);
            container.removeEventListener('paste', this._pasteHandler, false);
        }
        super.disconnectedCallback();
    }
    getViewValue(val) {
        return val;
    }
};
__decorate([
    ViewChild("div[pacem]")
], PacemContenteditableElement.prototype, "_container", void 0);
__decorate([
    ViewChild("div[dashboard]")
], PacemContenteditableElement.prototype, "_dashboard", void 0);
__decorate([
    Watch()
], PacemContenteditableElement.prototype, "range", void 0);
__decorate([
    Debounce(500)
], PacemContenteditableElement.prototype, "_updateHistory", null);
PacemContenteditableElement = __decorate([
    CustomElement({
        tagName: P + '-contenteditable', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-contenteditable ${PCSS}-viewfinder">
    <div contenteditable="true" role="presenter" pacem></div>
</div>${CHAR_COUNTER_CHILD}
<div dashboard>
    <${P}-content></${P}-content>
</div>`
    })
], PacemContenteditableElement);
export { PacemContenteditableElement };
